// @owners { team: patients }
import { type AltoAssistantActions, SET_DRAFT_MESSAGE, SET_SELF_SERVICE_EVENT } from '~shared/actions/altoAssistant';
import { type SelfServiceEvent } from '~shared/features/alto-assistant/constants';

export type StateAltoAssistant = {
  draftMessage: string;
  selfServiceEvent: SelfServiceEvent | null;
};

const initialState: StateAltoAssistant = {
  draftMessage: '',
  selfServiceEvent: null,
};

const altoAssistant = (state: StateAltoAssistant = initialState, action: AltoAssistantActions): StateAltoAssistant => {
  const { payload, type } = action;

  switch (type) {
    case SET_DRAFT_MESSAGE: {
      return {
        ...state,
        draftMessage: payload,
      };
    }

    case SET_SELF_SERVICE_EVENT: {
      return { ...state, selfServiceEvent: payload };
    }

    default:
      return state;
  }
};

export default altoAssistant;
